<template>
  <div class="portalAccount">
    <el-form :model="ruleForm" ref="ruleForm1" label-width="100px">
      <el-form-item v-if="ruleForm.wxState" label="." prop="wechat_open">
        <img :src="require(`@/assets/images/wechaticon.png`)" alt="">
        <el-input v-model.trim="ruleForm.wechat_open" placeholder="未绑定" disabled></el-input>
        <el-button class="resetPassBtn" v-show="!founderId" @click="handleChangeInfo('2')">{{ruleForm.wechat_open ? '解除绑定' : '绑定'}}</el-button>
      </el-form-item>
      <el-form-item v-if="ruleForm.orcidState" label="." prop="orcid">
        <img :src="require(`@/assets/images/orcidicon.png`)" alt="">
        <el-input v-model.trim="ruleForm.orcid" placeholder="未绑定" disabled></el-input>
        <el-button class="resetPassBtn" v-show="!founderId" @click="handleChangeInfo('3')">{{ruleForm.orcid ? '解除绑定' : '绑定'}}</el-button>
      </el-form-item>
      <el-form-item v-if="ruleForm.weiboState" label="." prop="weibo">
        <img :src="require(`@/assets/images/weiboicon.png`)" alt="">
        <el-input v-model.trim="ruleForm.weibo" placeholder="未绑定" disabled></el-input>
        <el-button class="resetPassBtn" v-show="!founderId" @click="handleChangeInfo('4')">{{ruleForm.weibo ? '解除绑定' : '绑定'}}</el-button>
      </el-form-item>
      <!-- <el-form-item label="启用状态" prop="enable">
        <el-switch v-model="ruleForm.enable" disabled></el-switch>
      </el-form-item> -->
    </el-form>
    
    <el-dialog
      :title=" providerId === 'wechat_open'? '微信登录' : providerId === 'weibo' ? '微博扫码登录' : 'ORCID登录'"
      width="600px"
      :visible.sync="dialogBindVisible"
      @close="initIframe"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <iframe :src="src" width = 500 height = 300 alt="" ></iframe>
    </el-dialog>
    <el-dialog title="解除绑定" width="500px" :visible.sync="dialogRemove">
        <div class="deleteText">解除绑定后，将无法使用{{providerId === 'wechat_open'?'微信扫码': providerId === 'weibo' ? '微博扫码' : 'ORCID'}}登录，确定要解绑吗？</div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteProvid">确 定</el-button>
          <el-button @click="dialogRemove = false">取 消</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/userManage.js"
import { Message } from "element-ui"

export default {
  data() {
    return {
      breadcrumb: [
        {
          label: "三方账号绑定"
        }
      ],
      founderId: false,
      ruleForm: {
        countName: "",
        userName: "",
        phone: "",
        email: "",
        enable: true,
        password: "ffounder123",
        wechat_open: '',
        orcid: '',
        fromFed: false,
        wxState: false,
        orcidState: false
      },
      realmName: this.$realm,
      userName: "",
      oldForm:{},//原始用户信息
      dialogBindVisible: false,
      providerId: '',
      dialogRemove: false,
      src: '',
      redirUrl: ""
    }
  },
  created() {
    this.founderId = location.href.indexOf('founderid') > -1 ? true : false;
    try {
      this.userName = this.$keycloak.tokenParsed.preferred_username
    } catch (error) {
      console.log(error)
    }
  },
  mounted() {
    if (this.userName) {
      this.getRealmsUserInfor()
    }
    let code = this.getQueryString('code'),
      state = this.getQueryString('state'),
      providerId =  this.getQueryString('providerId');
    this.redirUrl = this.getQueryString('redirUrl')
    if (providerId) {
      localStorage.removeItem('providerId')
      this.providerId = providerId
      this.bindRender()
    } 
    if(localStorage.getItem('providerId') && code && state) {
      this.providerId = localStorage.getItem('providerId')
      localStorage.removeItem('providerId')
      this.activeName = 'second'
      let params = {
        code,
        state
      }
      this.bindCallBack(params)
    }
  },
  methods: {
    // 获取账户信息详情
    async getRealmsUserInfor() {
      let { status, data } = await APIS.getPortalAccountInfo(
        this.realmName,
        this.userName
      )
      if (status === 0) {
        this.ruleForm.countName = data && data.accountname
        this.ruleForm.userName = data && data.username
        this.ruleForm.phone = (data && data.telephone) || ""
        this.ruleForm.email = data && data.email
        this.ruleForm.enable = data && data.enabled
        this.ruleForm.fromFed = data && data.fromFed
        this.ruleForm.wxState = data && data.wechatOpen
        this.ruleForm.orcidState = data && data.orcid
        this.ruleForm.wechat_open = ''
        this.ruleForm.orcid = ''
        if(data.federatedIdentities && data.federatedIdentities.length > 0){
          for(let i in data.federatedIdentities){
            if(data.federatedIdentities[i].identityProvider === 'wechat_open'){
              // this.ruleForm.wechat_open = data.federatedIdentities[i].userName
              this.ruleForm.wechat_open = '已绑定'
            }
            if(data.federatedIdentities[i].identityProvider === 'orcid'){
              this.ruleForm.orcid = '已绑定'
            }
            if(data.federatedIdentities[i].identityProvider === 'weibo'){
              this.ruleForm.weibo = '已绑定'
            }
          }
        }
        this.oldForm = JSON.parse(JSON.stringify(this.ruleForm))
      }
      this.oldForm = JSON.parse(JSON.stringify(this.ruleForm))
    },
    // 修改信息弹窗
    handleChangeInfo(type){
      // 解绑微信
      this.providerId = type === '2' ? 'wechat_open' : (this.providerId = type === '4' ? 'weibo' : 'orcid')
      this.ruleForm[this.providerId] ? this.dialogRemove = true : this.bindRender()
    },
    getQueryString(param) {
      var reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substring(1).match(reg);
      if (r != null) {
        return r[2];
      }
      return null;
    },
    bindRender(){
      localStorage.setItem('providerId', this.providerId)
      let src = ''
      if(this.redirUrl){
        src = `${ location.origin }/idaas/oauth/render/${ this.providerId }?url=${ location.href.split('?')[0] }?${ encodeURIComponent(`redirUrl=${this.redirUrl}`)}&realmName=${this.realmName}`
      } else {
        Message.error({
          message: "缺少必要参数"
        })
        return false
      }
      if(this.providerId === 'orcid' || this.providerId === 'weibo') {
        // location.href = encodeURIComponent(src)
        location.href = src
      } else {
        this.dialogBindVisible = true
        // this.src = encodeURIComponent(src)
        this.src = src
      }
    },
    initIframe(){
      localStorage.removeItem('providerId')
      this.src = ''
    },
    async bindCallBack(params){
      let { status } = await APIS.bindCallBack(
        this.providerId,
        `${location.href.split('?')[0]}?${ encodeURIComponent(`redirUrl=${this.redirUrl}`)}`,
        this.realmName,
        { data: params }
      )
      if (status === 0) {
        this.getRealmsUserInfor()
        // if(this.providerId === "wechat_open"){
        //   this.bindAccount(data.uuid, data.username)
        // } else {
        //   this.bindAccount(data.uuid)
        // }
      }
    },
    async bindAccount(id, username){
      let params = {
        userId: id,
        userName: this.userName
      }
      if(this.providerId === "wechat_open"){
        params.identityUserName = username
      }
      let { status } = await APIS.bindAccount(
        this.realmName,
        this.providerId,
        { data: params }
      )
      if (status === 0) {
        // location.href = location.href.split('?')[0]
        this.getRealmsUserInfor()
        this.redirUrl ? location.href = decodeURIComponent(this.redirUrl) : ''
      }
    },
    async deleteProvid(){
      let params = {
        userName: this.userName,
      }
      let { status } = await APIS.deleteProvid(
        this.realmName,
        this.providerId,
        { data: params }
      )
      this.dialogRemove = false
      if (status === 0) {
        this.getRealmsUserInfor()
        this.redirUrl ? location.href = decodeURIComponent(this.redirUrl) : ''
      }
    }
  }
}
</script>

<style lang="scss">
.founder-layout.menuService {
  display: none;
}
.ids-common-layout>.el-header{
  display: none;
}
.idsLeftNav{
  display: none;
}
// .ids-common-layout .el-header[data-v-1e2ac4f2]{
//   display: none;
// }
.portalAccount {
  .title{
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    color: #333;
  }
  .el-form {
    .el-form-item{
      .el-form-item__content{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-left: 0!important;
				flex-direction: row;
        .el-input{
          width: 50%;
          margin-right: 10px;
        }
        img{
          position: absolute;
          left: -40px;
        }
      }
    }
    .resetPassBtn {
      width: 60px;
      font-weight: normal;
      margin-left: 14px;
      margin-top:5px;
      color: #4497ec;
      cursor: pointer;
      text-align:left;
      padding: 0;
      border:0;
      background:#fafafa;
    }
    .resetPassBtn.is-disabled{
      color: #999;
    }
    .resetPassBtn.is-disabled:hover { 
      color: #999;
      cursor: not-allowed;
      background-image: none;
      border-color: #ececec; 
    }
  }
  .el-dialog {
    &__title {
      color: #333333;
      font-weight: 600;
    }
    &__body {
      // padding: 0 50px;
      .deleteText {
        text-align: center;
        height: 50px;
        line-height: 50px;
      }
      .el-input{
        width: auto!important;
        flex-grow: 1;
      }
    }
  }
  .el-tabs {
    &__nav-wrap {
      padding-left: 32px;
    }
  }
  .border-box{
    border: 1px solid rgba(0,0,0,0.125);
    padding: 10px;
    border-radius: 4px;
  }
  .border-box-sec{
    margin-top: 20px;
  }
  .el-switch{
    margin-top: 10px
  }
  .send-code{
    margin-right: 10px;
    width: 120px;
  }
  iframe{
    height: 400px;
  }
}
@media (max-width: 768px) {
  .portalAccount .el-dialog {
    width: 90%!important;
  }
  .portalAccount .el-dialog__body {
    padding-left: 0!important;
    padding-right: 10px!important;
  }
  .portalAccount .el-form {
    width: 100%;
  }
}
</style>
